import React from "react";
import CloseIcon from "@material-ui/icons/Close";
export function GDPRPopup({ handleGDPRPolicy, acceptCookies }) {
  return (
    <div id="GDPR_MainContainer" style={{ zIndex: 99 }}>
      <div id="GDPR_Container">
        <div className="GDPR_Leftcontent">
          <p className="GDPRText CookiePopup">
            By continuing to use this site, you agree to the use of cookies to
            provide you with better services. Read our{" "}
            {/* eslint-disable-next-line */}
            <a
              // onClick={handleGDPRPolicy}
              href="https://www.learnship.com/en/privacy-policy/?source=ls"
              target="_blank"
              id="cookie_policy"
              title="cookies policy"
            >
              <span>cookies policy</span>
            </a>
            .
          </p>
        </div>
        <div className="GDPR_right">
          <span
            id="accept_cookie"
            onClick={acceptCookies}
            style={{
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "14px",
              color: "#000",
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </div>
    </div>
  );
}
